<template>
  <div>
    <b-modal
      id="assignPosID"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      :visible="showSingleAssign"
      @show="setPosition()"
      @hidden="closeAssignSinglePosition()"
    >
      <div>
        <div
          class="d-flex align-items-center justify-content-between pt-3 px-4"
        >
          <div v-if="id === 'Allocate'" class="b-modal-header">
            Delete Recruiter
          </div>
          <div v-else class="b-modal-header">
            {{ !positionAssignType ? "Assign " : "Change " }} Position ID
          </div>
          <div class="rotate-on-hover pointer">
            <img
              :class="showSpinner && 'disabled-kanban-img'"
              @click="!showSpinner && closeAssignSinglePosition()"
              v-b-tooltip.hover.top="'Close'"
              src="../../../assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <hr />
        <div>
          <div class="d-flex align-items-center px-4">
            <div class="set-w-px">
              <img
                src="../../../assets/new-kanban-icons/inform-icon.svg"
                alt=""
              />
            </div>
            <div class="ml-1">
              <div v-if="id === 'Allocate'" class="addTocandJob-head">
                Existing Position IDs tagged to<strong>
                  “{{ candidate.name }}” </strong
                >has to be reallocated
              </div>
              <div v-else class="addTocandJob-head">
                Assign {{ positionAssignType && " different " }} position ID to
                <strong> “{{ candidate.name }}”? </strong>
              </div>
              <div v-if="id === 'Allocate'" class="addTocandJob-subhead">
                Choose 'Assign Automatically' for auto-assignment or assign
                manually.
              </div>
              <div v-else class="addTocandJob-subhead">
                Select position IDs to assign to the candidates.
              </div>
              <div
                v-if="id === 'Allocate'"
                class="mt-2 new-center-radio d-flex align-items-center"
              >
                <b-form-radio
                  v-model="assignData"
                  class="wordbreak"
                  value="auto"
                >
                  Assign Automatically
                </b-form-radio>
                <b-form-radio
                  v-model="assignData"
                  class="wordbreak ml-3"
                  value="manual"
                >
                  Assign Manually
                </b-form-radio>
              </div>
            </div>
          </div>
          <div class="mt-3 px-1">
            <div v-if="id === 'Allocate'" class="available-font px-4">
              Position IDs tagged to<strong> “{{ candidate.name }}”</strong>:
            </div>
            <div v-else class="available-font px-4">
              Available Position IDs:
            </div>
            <div
              class="
                d-flex
                align-items-center
                flex-wrap
                available-overflow
                px-4
                mt-3
              "
              :style="
                positionAssignType == 'change' &&
                'max-height: 145px !important;'
              "
              style="gap: 20px"
            >
              <div
                @click="
                  id !== 'Allocate' && !showSpinner && selectPosition(pos)
                "
                :class="{
                  'selected-id': id !== 'Allocate' && selectedPosition === pos,
                  pointer: id !== 'Allocate',
                }"
                class="unselected-id"
                v-for="pos in positionIDs"
                :key="pos"
              >
                {{ pos }}
              </div>
            </div>
            <template
              v-if="positionAssignType == 'change' && leadPositions.length != 0"
            >
              <div class="available-font px-4 mt-2">
                Your Allocated Position IDs:
              </div>
              <div
                class="
                  d-flex
                  align-items-center
                  flex-wrap
                  available-overflow
                  px-4
                  mt-3
                "
                style="gap: 20px"
                :style="
                  positionAssignType == 'change' &&
                  'max-height: 145px !important;'
                "
              >
                <div
                  @click="!showSpinner && selectPosition(pos)"
                  :class="{
                    'selected-id': selectedPosition === pos,
                  }"
                  class="unselected-id pointer"
                  v-for="pos in leadPositions"
                  :key="pos"
                >
                  {{ pos }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <hr />
        <div
          class="d-flex align-items-center w-100 bluebtn mb-3"
          :class="{
            'justify-content-end': positionAssignType || id === 'Allocate',
            'justify-content-between': !positionAssignType && id !== 'Allocate',
          }"
        >
          <div v-if="!positionAssignType && id !== 'Allocate'">
            <b-button
              class="acs-cancelBtn-modal ml-3"
              :disabled="showSpinner"
              @click="!showSpinner && closeAssignSinglePosition()"
              >Back</b-button
            >
          </div>
          <div class="d-flex align-items-center">
            <b-button
              class="acs-cancelBtn-modal mr-3"
              :disabled="showSpinner"
              @click="!showSpinner && closeAssignSinglePosition()"
              >Cancel</b-button
            >
            <div class="position-relative">
              <button
                v-if="id === 'Allocate'"
                class="acs-addBtn-modal pl-4 pr-4 mr-3"
                @click="$emit('add-to-job', assignData)"
              >
                Continue
              </button>
              <b-button
                v-else
                class="acs-addBtn-modal pl-4 pr-4 mr-3"
                :class="
                  showSpinner ? 'send-loader-class defaultCursor' : 'pointer'
                "
                :disabled="!selectedPosition || checkChanged"
                @click="
                  selectedPosition &&
                  !positionAssignType &&
                  !showSpinner &&
                  !checkChanged
                    ? addCandsToJob()
                    : selectedPosition
                    ? changeCandPositionID()
                    : ''
                "
                >{{ showSpinner ? "" : "Save" }}</b-button
              >
              <div v-if="showSpinner" class="send-loader-pos">
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { changePositionID } from "../../../utils/apiFunctions";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import toast from "../../mixin/toast";
import { mapGetters } from "vuex";
export default {
  name: "AssignSinglePosition",
  props: {
    showSingleAssign: Boolean,
    failure: Boolean,
    id: String,
    positionAssignType: String,
    positionIDs: Array,
    candidate: Object,
    leadPositions: Array,
  },
  data() {
    return {
      assignData: "auto",
      selectedPosition: null,
      showSpinner: false,
    };
  },
  components: {
    Loader,
  },
  mixins: [toast],
  watch: {
    failure(val) {
      if (val) {
        this.showSpinner = false;
        this.$emit("change-failure");
      }
    },
  },
  computed: {
    ...mapGetters("jobDescriptionVUEX", {
      getCustomerDetail: "getCustomerDetail",
    }),
    checkChanged() {
      if (this.positionAssignType) {
        return this.selectedPosition == this.candidate.positionID;
      } else {
        return false;
      }
    },
  },
  methods: {
    setPosition() {
      if (this.positionAssignType) {
        this.selectedPosition = this.candidate.positionID;
      }
    },
    closeAssignSinglePosition() {
      this.selectedPosition = null;
      this.$emit("close-modal");
    },
    selectPosition(pos) {
      this.selectedPosition = pos;
    },
    addCandsToJob() {
      this.showSpinner = true;
      let candidateData = this.candidate;
      candidateData.positionID = this.selectedPosition;
      let arr = [];
      arr.push(candidateData);
      this.$emit("add-to-job", arr);
    },
    async changeCandPositionID() {
      this.showSpinner = true;
      try {
        let payload = {
          type: 1,
          oldPositionID: this.candidate.positionID,
          newPositionID: this.selectedPosition,
          candidateID: this.candidate.candidateID,
          jobID: this.$route.query.jobID,
          force: true,
          reassign: true,
          lead: this.getCustomerDetail.lead,
        };
        const res = await changePositionID(payload);
        if (res.status == 200) {
          this.dynamicToast(
            "success",
            "Successfully changed",
            `Position id of candidate "${this.candidate.name}" has been changed successfully.`
          );
          this.$emit("update-data");
          this.closeAssignSinglePosition();
        } else {
          this.showSpinner = false;
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        console.error(error);
        this.showSpinner = false;
        this.errorModal("Something went wrong!");
      }
    },
  },
};
</script>

<style>
.addTocandJob-head {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: #333333;
}

.addTocandJob-subhead {
  font-family: "Montserrat", sans-serif;
  font-style: italic;
  font-weight: 500;
  font-size: 11px;
  line-height: 20px;
  color: #70737b;
}

.available-font {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #3a3c40;
}

.unselected-id {
  padding: 2px 13px;
  background: #f6f9fb;
  border-radius: 8px;
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #3a3c40;
}

.selected-id {
  background: #20639b;
  color: #ffffff;
}

.available-overflow {
  min-height: auto;
  max-height: 250px;
  overflow: auto;
}

#assignPosID .modal-body {
  padding: 0px;
}
</style>
